import React from 'react'
import DrainSlitComplaintReportView from './DrainSlitComplaintReportView'
import { useDrainSlitComplaintExcelExport } from './ExportDrainSlitComplaintExcel'
import { useDrainSlitComplaintPdfExport } from './ExportDrainSlitComplaintPdf'
import ExportMenu from '../../../../Common/ExportMenu/ExportMenu'

const DrainSlitRootComponent = () => {
  const downloadExcel = useDrainSlitComplaintExcelExport()
  const downloadPDF = useDrainSlitComplaintPdfExport()

  return (
   <>
   <div className="content text-start">
      <div className="page-content">
        <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mt-3">
          <div>
            <h5 className="mb-1 fw-semibold">Drain Slit Complaint Report Information</h5>
           
          </div>
          <ExportMenu
            items={[
              { label: "Excel", icon: "fa-solid fa-file-excel", onClick: downloadExcel },
              { label: "PDF", icon: "fa-solid fa-file-pdf", onClick: downloadPDF },
            ]}
          />
        </div>
        <DrainSlitComplaintReportView />
       
      </div>
    </div >
   </>
  )
}

export default DrainSlitRootComponent
